import React from "react";
import { Box } from "../../../../design-system";
import { ProfileIcon } from "../../../../design-system/icons";
import { colors } from "../../../../design-system/colors";

const AVATAR_SIZE = 38;
const PROFILE_ICON_SIZE = 24;

interface TopBarAvatarProps {
  onClick: () => void;
  isActive?: boolean;
}

const TopBarAvatar = ({ onClick, isActive = false }: TopBarAvatarProps) => {
  return (
    <Box
      component="button"
      aria-label="Account menu"
      aria-haspopup="menu"
      aria-expanded={isActive}
      onClick={onClick}
      sx={{
        width: `${AVATAR_SIZE}px`,
        height: `${AVATAR_SIZE}px`,
        borderRadius: "50%",
        backgroundColor: isActive ? colors.primary[500] : colors.topBar.avatarBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        border: "none",
        "&:focus-visible": {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: "2px",
        },
      }}
    >
      <ProfileIcon
        size={PROFILE_ICON_SIZE}
        color={colors.topBar.avatarInitials}
      />
    </Box>
  );
};

export default TopBarAvatar;
